import styles from "./styles.module.scss";
import React, { useEffect } from "react";
import useCollapse from "react-collapsed";
import { Link } from "react-router-dom";

function Collapsible() {
    const { getCollapseProps, getToggleProps, isExpanded } = useCollapse({ duration: 1000 });
    return (
        <div className={styles.collapsible}>
            <div className={styles.header} {...getToggleProps()}>
                <p>{isExpanded ? '-' : '+'}</p>
                <text>ERP : avantages et caractéristiques</text>
            </div>
            <div {...getCollapseProps()}>
                <div className={styles.content}>

                    <p>Optimisation des processus de gestion</p>
                    <p>Unicité de la base de données</p>
                    <p>Meilleure gestion des activités de l’entreprise</p>
                    <p>Diminution des saisies et des erreurs liées à la mauvaise transmission de l’information</p>
                    <p>Meilleure satisfaction client</p>
                    <p>Meilleure collaboration et coordination entre les différents services</p>
                </div>
            </div>
        </div>
    );
}
function Collapsible2() {
    const { getCollapseProps, getToggleProps, isExpanded } = useCollapse({ duration: 1000 });
    return (
        <div className={styles.collapsible}>
            <div className={styles.header} {...getToggleProps()}>
                <p>{isExpanded ? '-' : '+'}</p>
                <text>ERP : solution de gestion intégrée</text>
            </div>
            <div {...getCollapseProps()}>
                <div className={styles.content}>
                    <p>Gestion des achats et des ventes</p>
                    <p>Logistique gestion de stocks</p>
                    <p>Gestion de la comptabilité finance</p>
                    <p>Gestion de la production</p>
                    <p>Gestion des Ressources Humaines</p>
                    <p>Management du projet</p>
                </div>
            </div>
        </div>
    );
}

function Intro() {
    useEffect(() => {
        window.scrollTo(0, 1000)
    }, [])

    return (
        <>
            <section className={styles.container}>
                <div className={styles.title}>
                    <text>Intégration ERP</text>
                    <p>pour la réussite de vos projets</p>
                </div>
                <div className={styles.bigbox}>

                    <div className={styles.service}>
                        <div className={styles.bigText}>ERP</div>
                        <div className={styles.paragraph}>
                            L’accès des entreprises aux nouvelles technologies, tend à modifier la communication entre les différents acteurs du monde des affaires.
                            <br /><br />
                            Notamment entre votre entreprise et vos clients, le fonctionnement interne de votre entreprise  et la relation avec vos différents partenaires et fournisseurs.
                            <br /><br />
                            Notre solution de planification des ressources de l’entreprise vise à rassembler les différents processus liés à l’activité de l’entreprise dans un système d’information unique, couvrant ainsi un large périmètre de gestion et de traitements des divers départements des institutions.
                            <br /><br />
                            La mise en place d’un logiciel ERP obéit à des étapes spécifiques et relève d’un processus complexe impliquant des dimensions techniques, humaines et organisationnelles. Chez OrgaExpert, nous accordons le plus grand soin à l’accomplissement de chaque étape.
                            <br /><br />
                            Notre méthodologie s’articule autour de 3 étapes clés :
                            <br /><br />

                            <p>Analyse et audit de la situation actuelle</p>
                            <p>Définition des besoins</p>
                            <p>Indentification de la solution</p>
                        </div>
                    </div>


                    <div className={styles.expandable}>
                        <Collapsible />
                        <Collapsible2 />
                    </div>

                </div>
                <div className={styles.title}>
                    <div className={styles.text2}>Autre services</div>
                </div>
                <div className={styles.bigbox2}>
                    <Link to="/services/developpementMobile">
                        <div className={styles.service1}>
                            <div className={styles.bigText}>Développement Mobile</div>
                            <img src="/icons/smartphone.png" alt="web dev" />
                        </div>
                    </Link>
                    <Link to="/services/developpementWeb">
                    <div className={styles.service1}>
                        <div className={styles.bigText}>Développement Web</div>
                        <img src="/icons/desktop.png" alt="web dev" />
                    </div>
                    </Link>
                    <Link to="/services/e_commerce">
                        <div className={styles.service1}>
                            <div className={styles.bigText}>E-COMMERCE ET MARKETPLACES</div>
                            <img src="/icons/e-commerce.png" alt="web dev" />

                        </div>
                    </Link>
                    <Link to="/services/transformation_digital">
                        <div className={styles.service1}>
                            <div className={styles.bigText}>CONSEIL ET STRATÉGIE</div>
                            <img src="/icons/assist.png" alt="web dev" />

                        </div>
                    </Link>
                    <Link to="/services/seo">
                        <div className={styles.service1}>
                            <div className={styles.bigText}>SEO ET OPTIMISATION</div>
                            <img src="/icons/seo.png" alt="web dev" />
                        </div>
                    </Link>
                </div>
            </section>
        </>
    )
}

export default Intro;